module.exports = __webpack_public_path__ + "static/media/Component 58 – 13.65588dce.svg";